import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LoadingMore from '@src/mobile/components/LoadingMore';
import { getTimelineList } from '../service';
import { ListStore } from '../store';
import styles from './index.css';
import Filter from './Filter';
import Spin from './Spin';
import EventList from '@src/pc/components/EventList';
import { EVENT_LIST_PAGE } from '@src/public/constants';

const Main = ({ content }) => {
    const { id, qrcode, noticeText } = content;
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const {
        page,
        size,
        party,
        highlights,
        order,
        total,
        nodes,
        allFold,
        parties,
        title,
        allowComment,
        summary,
        shareImgUrl,
    } = listStates;

    const initData = () => {
        getTimelineList({ id, page, size, party, highlights, order })
            .then(res => {
                const { nodes = [], pagination, parties, timeline } = res;
                const { total } = pagination;
                const {
                    id,
                    allowComment,
                    finish,
                    follow,
                    displayTitle: title,
                    summary = '',
                    shareImgUrl = '',
                    interactionRsp,
                    pcBackground = {},
                } = timeline;
                const party = parties[0].id;

                const {
                    color: pcBgColor = '#fff',
                    fade: pcBgFade = 0,
                    img: pcBgImg = 'https://x0.ifengimg.com/fe/custom/2022_03_15/6de1cc79253189c3c05055809c945976.png',
                } = pcBackground;

                const pcBgInfo = {
                    pcBgColor,
                    pcBgShowFade: pcBgFade === 1,
                    pcBgImg,
                };

                changeListStates({
                    id,
                    order: finish === 1 ? 'asc' : 'desc',
                    page: page + 1,
                    parties,
                    total,
                    nodes,
                    allowComment: allowComment === 1,
                    title,
                    summary,
                    shareImgUrl,
                    finish,
                    follow: follow === 1,
                    party,
                    interactionRsp,
                    pcBgInfo,
                });

                document.title = title;
            })
            .catch(e => {
                changeListStates({ online: false });
            });
    };

    const loadMoreData = async () => {
        if ((page - 1) * size < total) {
            const res = await getTimelineList({
                id,
                page,
                size,
                party,
                highlights,
                order,
            });
            const { nodes: newNodes = [], pagination } = res;
            const { total } = pagination;

            changeListStates({
                nodes: [...nodes, ...newNodes],
                page: page + 1,
                total,
            });

            return 'success';
        } else {
            return 'end';
        }
    };

    useEffect(() => {
        initData();
    }, []);

    return (
        <div className={styles.wrap}>
            <Filter id={id} noticeText={noticeText} />
            <div className={styles.listWrap}>
                <EventList
                    content={{
                        nodes,
                        parties,
                        timeline: {
                            id,
                            title,
                            allowComment,
                            summary,
                            qrcode,
                            shareImgUrl,
                        },
                    }}
                    showType={EVENT_LIST_PAGE}
                    allFold={allFold}
                    changeAllFold={bool => {
                        changeListStates({ allFold: bool });
                    }}
                />
            </div>
            {nodes.length > 0 ? <LoadingMore control={loadMoreData} /> : <Spin />}
        </div>
    );
};

Main.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Main);
